/* eslint-disable jsx-a11y/control-has-associated-label,jsx-a11y/alt-text */

'use client';

import styled from '@emotion/styled';
import { useRouter, useSearchParams } from 'next/navigation';
import { useCallback, useState } from 'react';
import { WebViewScreen } from '@diritto/common/app/webview-header.constant';
import { isPC } from '@/constants/layout';
import { VoteTab } from '@/app/(appHeader)/promotions/2025-pick-and-choo/vote/components/VoteTab';
import { MutableHeaderLayout } from 'ui-components/layout/MutableHeaderLayout';
import { useInAppHeader } from 'ui-hooks/useInAppHeader';
import { useInAppStatusBar } from 'ui-hooks/useInAppStatusBar';
import { configure } from 'utils/configure';

export const ContestVoteEventPage = ({ isApp, currentYyyymmdd }: { isApp?: boolean; currentYyyymmdd: string }) => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const defaultTab = searchParams?.get('tab') as 'vote' | 'content' | null;
  const [activeTab, setActiveTab] = useState<'vote' | 'content'>(defaultTab || 'vote');

  const onClickTab = useCallback(
    (tab: 'vote' | 'content') => {
      setActiveTab(tab);
      router.replace(`/promotions/2025-pick-and-choo/vote?tab=${tab}`, { scroll: false });
      document.getElementById('top')?.scrollIntoView();
    },
    [router],
  );

  useInAppHeader({ screen: WebViewScreen.PickAndChoo, title: '픽앤츄 with RIDI' });
  useInAppStatusBar(WebViewScreen.PickAndChoo);

  const handleClickTab = (tab: 'apply' | 'vote' | 'result') => {
    if (tab === 'apply') {
      router.push('/promotions/2025-pick-and-choo/apply');
    } else if (tab === 'vote') {
      router.push('/promotions/2025-pick-and-choo/vote');
    } else if (tab === 'result') {
      router.push('/promotions/2025-pick-and-choo/top10');
    }
  };

  return (
    <MutableHeaderLayout title="2025 판타지 픽앤츄" noBottomPadding isApp={isApp}>
      <div className="w-full h-[91px] p-2 bg-[#0c0c0c] flex justify-center items-center gap-2.5 inline-flex">
        <div className="w-full sm:max-w-[390px] self-stretch p-1.5 bg-white rounded-[122px] justify-center items-center inline-flex">
          <div
            className="grow shrink basis-0 h-[63px] rounded-[112px] flex-col justify-center items-center gap-[3px] inline-flex cursor-pointer"
            onClick={() => handleClickTab('apply')}>
            <div className="text-center text-gray-800 text-xxs font-medium">픽앤츄 접수마감</div>
            <div className="opacity-80 text-center text-gray-800 text-xxxs font-medium">안내 다시보기</div>
          </div>
          <div
            className="grow shrink basis-0 h-[63px] bg-[#a088ff] rounded-[112px] flex-col justify-center items-center gap-[3px] inline-flex cursor-pointer"
            onClick={() => handleClickTab('vote')}>
            <div className="text-center text-white text-xxs font-medium">픽앤츄 투표</div>
            <div className="text-center text-primary-200 text-xxxs font-medium">최대 1,000P 받기</div>
          </div>
          <div
            className="grow shrink basis-0 h-[63px] rounded-[112px] flex-col justify-center items-center gap-[3px] inline-flex cursor-pointer"
            onClick={() => handleClickTab('result')}>
            <div className="text-center text-gray-800 text-xxs font-medium">결과발표</div>
            <div className="opacity-80 text-center text-gray-800 text-xxxs font-medium">2025. 03. 10</div>
          </div>
        </div>
      </div>
      <div className="relative flex flex-col items-center gap-0">
        <div className="flex justify-center w-full bg-[#EFEBFA]">
          <img
            alt="event"
            src={`${configure.staticPrefix}/images/contests/3/vote/event/1.png?03`}
            className="w-full h-auto"
          />
        </div>
        <div id="top" />
        <div className="flex justify-center w-full bg-[#EFEBFA] sticky top-0 z-40 cursor-pointer">
          <div
            className={`grow shrink basis-0 self-stretch px-[30px] py-[26px] pc:px-[60px] pc:py-[50px] bg-[#6c4af8] justify-center items-center flex ${
              activeTab === 'vote' ? 'opacity-100' : ' opacity-60'
            }`}
            role="button"
            onClick={() => onClickTab('vote')}>
            <div className="text-center text-white font-semibold text-xxs leading-[20px] pc:text-[22px] pc:leading-[30px]">
              픽앤츄 투표 방식 안내
            </div>
          </div>
          <div
            className={`grow shrink basis-0 self-stretch px-[30px] py-[20px] pc:px-[60px] pc:py-[50px] bg-[#6c4af8] justify-center items-center flex ${
              activeTab === 'content' ? 'opacity-100' : ' opacity-60'
            }`}
            role="button"
            onClick={() => onClickTab('content')}>
            <div className="text-center text-white font-semibold text-xxs leading-[20px] pc:text-[22px] pc:leading-[30px]">
              픽앤츄 작품 보러 가기
            </div>
          </div>
        </div>
        <VoteTab currentYyyymmdd={currentYyyymmdd} />
        {/* {activeTab === 'vote' ? ( */}
        {/* <VoteTab currentYyyymmdd={currentYyyymmdd} /> */}
        {/* ) : ( */}
        {/* <ContentTab currentYyyymmdd={currentYyyymmdd} /> */}
        {/* )} */}
      </div>
    </MutableHeaderLayout>
  );
};

export const StyledScaleWrapper = styled.div<{ scale: number }>`
  transform: scale(${({ scale = 0.3 }) => scale});
  transition: width 0.3s ease-in-out;

  @media (${isPC}) {
    transform: scale(1);
  }
`;
